import React from 'react';
import NavBar from './NavBar';


function Header() {
    return (
        <header>
            <h1>Ice Cream Shop Finder</h1>
            <NavBar />
        </header>
    )
}

export default Header;